// 3rd party design libraries
import { Alert, Table } from "antd";
import ChantPopConfirm from "../../../../../CommonComponents/ChantTooltip/ChantPopConfirm";

// api end points

// common components
import React, { useState, useEffect, useCallback } from "react";
import Ticket from "../../../../../models/admin/Ticket";
import useAdminDataStore, {
  selectCurrentGroupData,
} from "../../../../../store/adminData/adminData";
import { fbGetTicketDetails } from "../../../../../services/firebaseService/endPoints/admin/tickets";
// 3rd party helper libraries
import moment from "moment";

import { db } from "../../../../../services/firebaseService/connection";

import { deleteField, doc, getDoc, updateDoc } from "firebase/firestore";
import logger from "../../../../../utils/logger";
import { CSVLink } from "react-csv";
import dayjs from "dayjs";
import { ChantButton, ScreenHeader } from "../../../../../CommonComponents";
import useCurrency from "../../../../../utils/hooks/useCurrency";
import { useParams } from "react-router-dom";
import ExpandedTicketRow from "./ExpandedTicketRow";
import EventSummary from "./EventSummary";
import { toast } from "react-toastify";
import useMembersData from "../../../members/Members/useMembersData";
import { TICKET_DETAILS_WIDTHS } from "../../../../../constants/tableWidths";
import { chantApi } from "../../../../../utils/chantApi";

// constants
const options = [
  {
    value: "on submit",
    label: "On Submit",
  },
  {
    value: "day of event",
    label: "Day of Event",
  },
  {
    value: "1 day before event",
    label: "1 day before event",
  },
];
for (let i = 2; i <= 28; i++) {
  options.push({
    value: `${i} day before event`,
    label: `${i} day's before event`,
  });
}

const TicketDetails = () => {
  // Individual state variables
  const [eventDate, setEventDate] = useState("");
  const [type, setType] = useState("");
  const [location, setLocation] = useState("");
  const [eventDescription, setEventDescription] = useState("");
  const [errorInForm, setErrorInForm] = useState({
    isError: false,
    visible: false,
    message: "",
  });
  const [downloadedOn, setDownloadedOn] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [eventName, setEventName] = useState("");
  const [eventCode, setEventCode] = useState("");
  const [tickets, setTickets] = useState([]);
  const [editableRecordId, setEditableRecordId] = useState("");
  const [editableRecord, setEditableRecord] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [matchName, setMatchName] = useState("");

  const groupData = useAdminDataStore(selectCurrentGroupData);
  const ticketId = useParams()?.id || null;
  const groupCurrency = useCurrency();
  const { membersList } = useMembersData();

  const handleErrorMessageClose = () => {
    setErrorInForm((prev) => ({
      ...prev,
      visible: false,
    }));
  };

  const handleTicketRefresh = () => {
    fetchDetail();
  };

  const handleSetEditableRecordId = (id) => {
    // TODO GET MEMBER FROM REDUX
    // getSingleMemberFromLocal(groupData?.id, id).then((data) => {
    //   if (data) {
    //     setEditableRecord(data);
    //     setEditableRecordId(id);
    //   }
    // });
  };

  const saveDetail = (updatedData, id, email) => {
    if (updatedData.fullName) {
      updatedData = {
        ...updatedData,
        name: updatedData.fullName,
      };
    }

    if (typeof id === "number") {
      let docRef = doc(db, "invite_emails", groupData?.id);

      getDoc(docRef).then((doc) => {
        if (doc.exists()) {
          let userDetails = (doc.data() || {}).userDetails;
          let id = email;
          let filteredDocs = Object.keys(userDetails || {}).filter(
            (key) => userDetails[key] && userDetails[key].email === email,
          );
          if (filteredDocs.length > 0) {
            id = filteredDocs[0];
          }
          if (userDetails) {
            let userDetailObj = userDetails[id];
            let updatedUserDetailObj = {
              ...userDetailObj,
              ...updatedData,
            };

            if (!updatedData.tshirtSize) {
              delete updatedUserDetailObj.tshirtSize;
            }

            userDetails[id] = updatedUserDetailObj;

            updateDoc(docRef, { userDetails });
          }
        }
      });
    } else {
      if (!updatedData.tshirtSize) {
        updatedData.tshirtSize = deleteField();
      }

      if (Object.prototype.hasOwnProperty.call(updatedData, "hometown")) {
        let homeTown = updatedData.hometown;
        if (!homeTown) {
          homeTown = "";
        }
        updateDoc(doc(db, "users", id), { homeTown });

        delete updatedData.homeTown;
      }

      updateDoc(doc(db, "userGroup", groupData?.id, "members", id), {
        ...updatedData,
      });

      let websiteCollectionRef = doc(db, "website", groupData?.id);
      if (updatedData?.title) {
        getDoc(websiteCollectionRef).then((doc) => {
          if (doc.exists() && doc.data().about) {
            let about = doc.data().about;
            let leadership = about.leadership;
            if (leadership && Array.isArray(leadership.leaders)) {
              let requiredDoc = leadership.leaders.find(
                (value) => value.id === id,
              );
              if (requiredDoc) {
                requiredDoc.title = updatedData.title;
                updateDoc(websiteCollectionRef, { about });
              }
            }
          }
        });
      }
    }
  };

  const fetchDetail = useCallback(async () => {
    try {
      if (!ticketId || !groupData?.id) {
        return;
      }

      setIsLoading(true);

      let doc = await fbGetTicketDetails(ticketId, groupData?.id);

      const ticketData = new Ticket();
      ticketData.fromDataSet(doc.data.body.data);

      const tickets = await chantApi.get(
        `${import.meta.env.VITE_GCP_BASE_URL}/tickets/getSingleGroupTicketPurchases?groupId=${groupData?.id}&ticketId=${ticketId}`,
      );

      let users = [];
      for (var data of tickets.data.body) {
        var user = {};
        user.customerId = data.id;
        user.paymentAmount = data.data.amountPaid;
        user.purchasedSubTickets = data.data.purchasedSubTickets;
        if (
          user.purchasedSubTickets &&
          Object.values(user.purchasedSubTickets).length > 0
        ) {
          user.paymentAmount = Object.values(user.purchasedSubTickets).reduce(
            (acc, val) => {
              acc += val.amountPaid;
              return acc;
            },
            0,
          );
        }
        user.paymentAmount += data.data.totalFees || 0;
        let quantity = data.data.noOfTicketsBrought;
        let usersList = [];
        if (!quantity && !!data.data.purchasedSubTickets) {
          quantity = 0;
          Object.values(data.data.purchasedSubTickets).forEach((ticketData) => {
            quantity += ticketData.ticketBought;
            usersList.push(...(ticketData.attendees || []));
          });
        }
        user.quantity = quantity || 0;
        user.purchasedDate = data.data.purchasedOn;
        user.name = data.data.purchasedBy
          ? typeof data.data.purchasedBy === "string"
            ? data.data.purchasedBy
            : typeof data.data.purchasedBy === "object"
              ? data.data.purchasedBy.name
              : ""
          : "";

        if (!data.data.usersList) {
          data.data.usersList = [];
        }

        const currentMember = membersList?.find(
          (memberId) => memberId === data.data.purchasedBy,
        );

        user.membershipNumber = currentMember?.membershipNumber || "";
        user.phone = currentMember?.phone || "";

        user.email =
          data.data.purchasedBy && typeof data.data.purchasedBy === "object"
            ? data.data.purchasedBy.email
            : usersList.length > 0
              ? usersList[0].email === ""
                ? "-"
                : usersList[0].email
              : "";
        if (
          !user?.email &&
          user?.email?.length === 0 &&
          usersList?.length === 0
        ) {
          user.email = currentMember?.email || "";
        }
        var guests = "";
        usersList.map((f) => {
          var isLast = usersList[usersList.length - 1] === f;
          var ifFirst = usersList[0] === f;
          if (ifFirst === false)
            guests =
              guests +
              `${(f.fullName || f.name) + (f.email ? `(${f.email})` : "")}` +
              `${isLast ? "" : " ; "}`;
        });

        user.guestNames = usersList.length > 1 ? guests : "-";

        // Use the event name from ticket details
        user.ticketName = ticketData.eventName || ticketData.matchName || "-";

        users.push(user);
      }

      // Sort by purchase date (latest first) - this implements the default sort requirement
      users.sort(
        (a, b) => dayjs(b.purchasedDate).unix() - dayjs(a.purchasedDate).unix(),
      );

      setTableData(users);
      setType(ticketData.type);
      setMatchName(ticketData.matchName);
      setEventName(ticketData.eventName);
      setEventDate(ticketData.eventDate);
      setLocation(ticketData.location !== null ? ticketData.location.name : "");
      setEventDescription(ticketData.eventDescription);
      setEventCode(ticketData.eventCode);
      setDownloadedOn(ticketData.lastDownloadOn);
      setTickets(ticketData.tickets || []);
    } catch (error) {
      toast.error("Error fetching ticket details");
      logger.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [groupData?.id, membersList, ticketId]);

  useEffect(() => {
    if (groupData?.id) {
      fetchDetail();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupData?.id]);

  const csvColumns = [
    {
      key: "name",
      label: "Member name",
    },
    {
      key: "email",
      label: "Email",
    },
    {
      key: "phone",
      label: "Phone Number",
    },
    {
      key: "membershipNumber",
      label: "Membership Number",
    },
    {
      key: "purchased_date",
      label: "Purchased Date",
    },
    {
      key: "purchased_timestamp",
      label: "Purchased Time",
    },
    {
      key: "quantity",
      label: "Quantity",
    },
    {
      key: "payment_amount",
      label: "Payment Amount($)",
    },
  ];

  const tableDatas = tableData;
  let dataArray = [];
  let subTicketAttendeesCountMap = {};

  let subTicketIds = tickets.map((ticketDetail) => {
    subTicketAttendeesCountMap[ticketDetail.id] = 0;
    return ticketDetail.id;
  });

  if (tableDatas) {
    tableDatas.map((data) => {
      let purchasedSubTickets = data.purchasedSubTickets;
      Object.keys(purchasedSubTickets || {}).map((key) => {
        if (
          subTicketAttendeesCountMap[key] <
          (purchasedSubTickets[key].attendees || []).length
        ) {
          subTicketAttendeesCountMap[key] = (
            purchasedSubTickets[key].attendees || []
          ).length;
        }
      });

      let temp = {
        name: data.name,
        email: data.email,
        membershipNumber: data.membershipNumber,
        phone: data.phone,
        purchased_date: dayjs(data.purchasedDate).format("Do MMM"),
        purchased_timestamp: dayjs(data.purchasedDate).format("HH:mm:ss"),
        quantity: data.quantity,
        payment_amount: data.paymentAmount,
      };
      subTicketIds.map((key, index) => {
        let subTicketPurchaseData = purchasedSubTickets[key];
        if (subTicketPurchaseData) {
          temp[`subTicket ${index + 1}`] = subTicketPurchaseData.name;
          temp[`ticketBought ${index + 1}`] =
            subTicketPurchaseData.ticketBought;
          (subTicketPurchaseData.attendees || []).forEach(
            (attendee, attendeeIndex) => {
              temp[`subTicket ${index + 1} GuestName ${attendeeIndex + 1}`] =
                attendee.fullName || "";
              temp[`subTicket ${index + 1} Email ${attendeeIndex + 1}`] =
                attendee.email || "";
            },
          );
        }
      });
      dataArray.push(temp);
    });
  }

  let tableDataMap = {
    name: "Member name",
    email: "Email",
    phone: "Phone Number",
    // guests: "Guest(s)",
    membershipNumber: "Membership Number",
    purchased_date: "Purchased Date",
    purchased_timestamp: "Purchase Timestamp",
    quantity: "Quantity",
    payment_amount: "Payment Amount($)",
  };

  tickets.forEach((_, index) => {
    tableDataMap[`subTicket ${index + 1}`] = `subTicket ${index + 1}`;
    csvColumns.push({
      id: `subTicket ${index + 1}`,
      displayName: `subTicket ${index + 1}`,
    });
    tableDataMap[`ticketBought ${index + 1}`] = `ticketBought ${index + 1}`;
    csvColumns.push({
      id: `ticketBought ${index + 1}`,
      displayName: `ticketBought ${index + 1}`,
    });
    let key = subTicketIds[index];
    Array.from(
      { length: subTicketAttendeesCountMap[key] },
      (_, subTicketIndex) => {
        tableDataMap[`subTicket ${index + 1} GuestName ${subTicketIndex + 1}`] =
          `subTicket ${index + 1} GuestName ${subTicketIndex + 1}`;
        csvColumns.push({
          id: `subTicket ${index + 1} GuestName ${subTicketIndex + 1}`,
          displayName: `subTicket ${index + 1} GuestName ${subTicketIndex + 1}`,
        });
        tableDataMap[`subTicket ${index + 1} Email ${subTicketIndex + 1}`] =
          `subTicket ${index + 1} Email ${subTicketIndex + 1}`;
        csvColumns.push({
          id: `subTicket ${index + 1} Email ${subTicketIndex + 1}`,
          displayName: `subTicket ${index + 1} Email ${subTicketIndex + 1}`,
        });
      },
    );
  });

  const columns = [
    {
      title: window.screen.width > 500 ? "Purchaser Name" : "Name",
      width: TICKET_DETAILS_WIDTHS.PURCHASER_NAME,
      className: "header-white",
      align: "center",
      key: "name",
      dataIndex: "name",
      render: (data, record) => {
        return (
          <a
            onClick={() => {
              handleSetEditableRecordId(record.customerId);
            }}
          >
            {data}
          </a>
        );
      },
      sorter: (a, b) => {
        if (a.name > b.name) {
          return -1;
        }
        if (a.name < b.name) {
          return 1;
        }
        return 0;
      },
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Ticket",
      width: TICKET_DETAILS_WIDTHS.TICKET,
      className: "header-white",
      key: "ticketName",
      dataIndex: "ticketName",
      align: "center",
    },
    {
      title: "Quantity",
      width: TICKET_DETAILS_WIDTHS.QUANTITY,
      key: "quantity",
      className: "header-white",
      align: "center",
      dataIndex: "quantity",
      sorter: (a, b) => a.quantity - b.quantity,
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Checked-in",
      width: TICKET_DETAILS_WIDTHS.CHECKED_IN,
      key: "checkedin",
      className: "header-white",
      align: "center",
      dataIndex: "checkedin",
    },
    {
      title: "Revenue",
      width: TICKET_DETAILS_WIDTHS.REVENUE,
      key: "revenue",
      className: "header-white",
      align: "center",
      dataIndex: "paymentAmount",
      render: (data) => {
        let dataAsFloat = parseFloat((data || "0").toString());
        let dataAsString = dataAsFloat.toFixed(
          Math.round(dataAsFloat) === dataAsFloat ? 0 : 2,
        );
        return <span>{data ? `${groupCurrency}${dataAsString}` : "-"}</span>;
      },
    },
    {
      title: "Purchase Date",
      align: "center",
      className: "header-white",
      width: TICKET_DETAILS_WIDTHS.PURCHASE_DATE,
      key: "purchasedDate",
      dataIndex: "purchasedDate",
      sorter: (a, b) =>
        moment(a.purchasedDate).unix() - moment(b.purchasedDate).unix(),
      sortDirections: ["descend", "ascend"],

      render: (purchasedDate) => {
        let startDate = "";
        if (purchasedDate) {
          startDate = moment.unix(Math.floor(purchasedDate / 1000));
          startDate = startDate.isValid() ? startDate.format("Do MMM") : "";
        }
        return <span>{startDate}</span>;
      },
    },
    {
      title: "Purchase Time",
      align: "center",
      className: "header-white",
      width: TICKET_DETAILS_WIDTHS.PURCHASE_TIME,
      key: "purchasedTime",
      dataIndex: "purchasedDate",
      sorter: (a, b) =>
        moment(a.purchasedDate).unix() - moment(b.purchasedDate).unix(),
      sortDirections: ["descend", "ascend"],

      render: (purchasedTime) => {
        let startTime = "";
        if (purchasedTime) {
          startTime = moment.unix(Math.floor(purchasedTime / 1000));
          startTime = startTime.isValid() ? startTime.format("HH:mm:ss") : "";
        }
        return <span>{startTime}</span>;
      },
    },
    {
      title: window.screen.width > 500 ? "Purchaser Email" : "Email",
      width: TICKET_DETAILS_WIDTHS.PURCHASER_EMAIL,
      className: "header-white",
      align: "center",
      key: "email",
      dataIndex: "email",
      sorter: (a, b) => {
        if (a.email > b.email) {
          return -1;
        }
        if (a.email < b.email) {
          return 1;
        }
        return 0;
      },
      sortDirections: ["ascend", "descend"],
    },

    {
      title: "Attendee(s)",
      align: "center",
      className: "header-white",
      key: "attendee",
      dataIndex: "attendee",
      width: TICKET_DETAILS_WIDTHS.ATTENDEES,
    },
  ];

  const csvData = [
    ["Ticket Type", type],
    ["Event Code", eventCode],
    ["Location", location !== "" ? location : "-"],
    ["Match", matchName !== "" ? matchName : "-"],
    ["Event Name", eventName !== "" ? eventName : "-"],
    ["Event Date", moment.unix(eventDate).format("Do MMM YYYY HH:MM")],
    ["Event Description", eventDescription !== "" ? eventDescription : "-"],
    [],
    [],
    Object.values(tableDataMap),
    ...dataArray.map((item) => Object.values(item)),
  ];
  // Create header actions
  const headerActions = (
    <>
      <ChantPopConfirm
        title="Refresh tickets?"
        onConfirm={handleTicketRefresh}
        onCancel={() => {}}
        okText="Yes"
        cancelText="No"
      >
        <ChantButton type="secondary">Refresh</ChantButton>
      </ChantPopConfirm>
      {Array.isArray(tableData) && tableData.length > 0 && (
        <CSVLink data={csvData} filename={"Tickets Purchase List.csv"}>
          <ChantButton>Download CSV</ChantButton>
        </CSVLink>
      )}
    </>
  );

  // Create summary data
  const summaryData = [
    { label: "Ticket Type", value: type || "N/A" },
    { label: "Event Code", value: eventCode || "N/A" },
    { label: "Location", value: location || "N/A" },
    {
      label: matchName ? "Match" : "Event Name",
      value: matchName || eventName || "N/A",
    },
    {
      label: "Event Date",
      value: eventDate ? moment.unix(eventDate).format("Do MMM YYYY") : "N/A",
    },
    {
      label: "Event Time",
      value: eventDate ? moment.unix(eventDate).format("HH:mm") : "N/A",
    },
  ];

  return (
    <div>
      {errorInForm.isError && errorInForm.visible && (
        <div className="mx-5 mt-2">
          <Alert
            message="Error"
            description={errorInForm.message}
            type="error"
            closable
            afterClose={handleErrorMessageClose}
          />
        </div>
      )}

      <div style={{ padding: "12px" }}>
        {/* Header Section */}
        <ScreenHeader
          title="Ticket Details"
          elementCount={tableData ? tableData.length : 0}
          actions={headerActions}
          secondaryData={
            window.screen.width > 500 && downloadedOn !== null ? (
              <div
                style={{ fontSize: "12px", color: "gray", fontStyle: "italic" }}
              >
                Last downloaded:{" "}
                {moment.unix(downloadedOn).format("Do MMM YYYY")}
              </div>
            ) : null
          }
        />

        {/* Summary Section */}
        <div style={{ marginTop: "var(--screen-general-margin)" }}>
          <EventSummary
            isLoading={isLoading}
            summaryData={summaryData}
            eventDescription={eventDescription}
          />
        </div>

        {/* Table Section */}
        <div>
          <Table
            bordered
            columns={columns}
            loading={isLoading}
            scroll={{ x: "max-content" }}
            dataSource={tableData}
            pagination={false}
            rowKey="customerId"
            size="middle"
            expandable={{
              expandedRowRender: (record) => (
                <ExpandedTicketRow record={record} loading={isLoading} />
              ),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TicketDetails;
